const courseIndex = resolve => {
  import('../views/course/index').then(courseIndex => {
    resolve(courseIndex)
  })
}
const courseInfo = resolve => {
  import('../views/course/info').then(courseInfo => {
    resolve(courseInfo)
  })
}
const courseApply = resolve => {
  import('../views/course/apply').then(courseApply => {
    resolve(courseApply)
  })
}
const courseCategory = resolve => {
  import('../views/course/categorylist').then(courseCategory => {
    resolve(courseCategory)
  })
}
const openCourseIndex = resolve => {
  import('../views/open/index').then(openCourseIndex => {
    resolve(openCourseIndex)
  })
}
const openCourseInfo = resolve => {
  import('../views/open/info').then(openCourseInfo => {
    resolve(openCourseInfo)
  })
}

const openCourseTestInfo = resolve => {
  import('../views/open/info-test').then(openCourseInfo => {
    resolve(openCourseInfo)
  })
}

const openCourseCategory = resolve => {
  import('../views/open/categorylist').then(openCourseCategory => {
    resolve(openCourseCategory)
  })
}
const subscribeList = resolve => {
  import('../views/course/subscribelist').then(subscribeList => {
    resolve(subscribeList)
  })
}
const courseList = resolve => {
  import('../views/course/courselist').then(courseList => {
    resolve(courseList)
  })
}

export default [
  {
    path: '/wechat/openCourse',
    name: 'course',
    component: openCourseIndex,
    meta: {
      title: '课程中心',
      requireAuth: false,
      keepAlive: false,
      footer: false,
    }
  },
  {
    path: '/wechat/openCourse/:id',
    name: 'course',
    component: openCourseInfo,
    meta: {
      requireAuth: false,
      keepAlive: false,
      footer: false,
    }
  },
  {
    path: '/wechat/openCourseTest/:id',
    name: 'course',
    component: openCourseTestInfo,
    meta: {
      requireAuth: false,
      keepAlive: false,
      footer: false,
    }
  },
  {
    path: '/wechat/openCourseCategory/:id',
    name: 'course',
    component: openCourseCategory,
    meta: {
      requireAuth: false,
      keepAlive: false,
      footer: false,
    }
  },
  {
    path: '/wechat/course',
    name: 'course',
    component: courseIndex,
    meta: {
      title: '课程中心',
      requireAuth: false,
      keepAlive: false,
      footer: true,
    }
  },
  {
    path: '/wechat/courseCategory/:id',
    name: 'course',
    component: courseCategory,
    meta: {
      requireAuth: false,
      keepAlive: false,
      footer: false,
    }
  },
  {
    path: '/wechat/course/:id',
    name: 'course',
    component: courseInfo,
    meta: {
      requireAuth: false,
      keepAlive: false,
      footer: false,
    }
  },
  {
    path: '/wechat/course/:id/apply',
    name: 'course',
    component: courseApply,
    meta: {
      requireAuth: false,
      keepAlive: false,
      footer: false,
    }
  },
  {
    path: '/wechat/coursesubscribelist',
    name: 'course',
    component: subscribeList,
    meta: {
      requireAuth: false,
      keepAlive: false,
      footer: false,
    }
  },
  {
    path: '/wechat/courselist',
    name: 'course',
    component: courseList,
    meta: {
      requireAuth: false,
      keepAlive: false,
      footer: false,
    }
  }
]
